export default __webpack_public_path__ + "static/media/smartphone3.913b2af7.svg";